import React, { Component } from 'react';
import Status from 'FielderUtils/status/taskStatus';
import RoleUtils from 'FielderUtils/roles/roleUtils';
import taskConst from 'FielderUtils/roleManagementConst/taskConst';
import Modal from '~/FielderElements/Modal';
import BranchIcon from '@assets/icons/branch-icon.svg';
import {
  listToTree,
  getAllTaskTypeList,
  getAllTaskTypeListPartner,
  hasTaskTypeDynamoTable,
  hasTaskTypeDynamoTablePartner,
} from 'FielderUtils/taskType/taskType';
import Grid from '@mui/material/Grid2';
import { connect } from 'react-redux';
import {
  Box,
  Chip,
  Link,
  Rating,
  Stack,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import ModifyTaskStatus from './ModifyTaskStatus';
import { isRoleValid } from '../../core/utils/roles/validateRoles';``
import EditorTask from '../CreateTask/EditorTask';
import Popup from '../Popup';
import TaskStatus from '~/Status/TaskStatus';
import { FIELDER } from '@core/constants/base.constants';
import DetailEditBranchOffice from 'OldComponents/BranchOffices/DetailEditBranchOffice';
import { FielderHard } from '@core/theme/baseTheme';
import useModal from 'antd/es/modal/useModal';
import { useLanguage } from 'Context/LanguageContext';
import { EditNoteOutlined, TrendingUp } from '@mui/icons-material';
import { SmartIconButton } from '~/FielderElements/SmartTaskTable/SmartStyles';
const { pop: POP_ID } = FIELDER.idElement;
const POP_EDIT_BRANCH = POP_ID.formBranch.replace('{0}', 'branchModal5');
const LabelText = (
  {
   label,
   text,
   showMoreInfo = false,
   onMoreInfo,
   sx,
 }) => {
  const theme = useTheme();
  const value = Array.isArray(text) ? text.join(' > ') : text ?? '';
  const lan = useLanguage();
  return (
    <Stack spacing={0.75} sx={sx}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ pb: 1 }}>
        {showMoreInfo && (
          <Link
            component="button"
            type="button"
            onClick={onMoreInfo}
            underline="hover"
            sx={{
              color: FielderHard,
              fontSize: 12,
              fontWeight: 600,
            }}
          >
            {lan.moreInformation}
          </Link>
        )}
      </Stack>
      <TextField
        label={label}
        value={value ?? ''}
        disabled
        variant="outlined"
        size="small"
        fullWidth
        slotProps={{
          input: {
            sx: {},
          },
        }}
      />
    </Stack>
  );
};
const LabelArea = ({ label, text, sx }) => {
  const theme = useTheme();
  return (
    <Stack spacing={0.75} sx={sx}>
      <TextField
        label={label}
        value={text ?? ''}
        disabled
        multiline
        minRows={3}
        variant="outlined"
        size="small"
        fullWidth
        slotProps={{
          input: {
            sx: {},
          },
        }}
      />
    </Stack>
  );
};
const Tags = ({ lan, tags = [], noTags }) => {
  const hasTags = Array.isArray(tags) && tags.length > 0;
  return (
    <Stack spacing={0.75}>
      <Typography variant="caption">
        {lan.tags}
      </Typography>
      {hasTags ? (
        <Box
          sx={{
            maxHeight: 90,
            overflowY: 'auto',
            pr: 0.5,
            display: 'flex',
            flexWrap: 'wrap',
            gap: 0.5,
          }}
        >
          {tags.map((t, i) => (
            <Chip key={`${t}-${i}`} label={`#${t}`} size="small" variant="outlined" />
          ))}
        </Box>
      ) : (
        <TextField value={noTags ?? ''} disabled variant="outlined" size="small" fullWidth />
      )}
    </Stack>
  );
};
class TaskInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      edit: false,
      statusTask: false,
      isAllowedToEditTask: false,
      showModifyTaskStatus: false,
      taskTypes: [],
      branchesToShow: {
        id: props.idBranch,
      },
    };
  }

  componentDidMount = () => {
    const isAllowedToEditTask = isRoleValid(taskConst.TASKS, taskConst.EDIT, this.props.session.roles);
    this.setState({ isAllowedToEditTask });

    const { partnerTaskRelations } = this.props;
    const idAccount = this.props.session.user.idAccount;
    const idUser = this.props.session.user.idUser;

    if (
      partnerTaskRelations &&
      partnerTaskRelations.accountOwner != null &&
      partnerTaskRelations.accountOwner.id !== idAccount &&
      partnerTaskRelations.accountOwner.idUserClient !== idUser &&
      partnerTaskRelations.partnerLevel === 1
    ) {
      const idAccountPartner = partnerTaskRelations.accountOwner.id;
      const idUserPartner = partnerTaskRelations.accountOwner.idUserClient;
      this.executeGetAllTaskInfoPartner(idAccountPartner, idUserPartner);
    } else {
      this.executeGetAllTaskInfo();
    }
  };

  executeGetAllTaskInfo = () => {
    hasTaskTypeDynamoTable().then((taskTypeFunctionality) => {
      if (taskTypeFunctionality) {
        getAllTaskTypeList(
          (formatTypes) => {
            const types = listToTree(formatTypes);
            this.setState({ taskTypes: types, taskTypeFunctionality });
          },
          this.props,
          true,
        );
      }
    });
  };

  executeGetAllTaskInfoPartner = (idAccountPartner, idUserPartner) => {
    hasTaskTypeDynamoTablePartner(idAccountPartner, idUserPartner).then((taskTypeFunctionality) => {
      if (taskTypeFunctionality) {
        getAllTaskTypeListPartner(
          (formatTypes) => {
            const types = listToTree(formatTypes);
            this.setState({ taskTypes: types, taskTypeFunctionality });
          },
          this.props,
          idAccountPartner,
          idUserPartner,
        );
      }
    });
  };

  clickModifyStatus = () => {
    this.setState({ showModifyTaskStatus: true });
    this.props.changeOpacity();
  };

  closeModifyStatus = (refresh) => {
    this.setState({ showModifyTaskStatus: false });
    this.props.changeOpacityReset();
    if (refresh) this.props.executeRefresh();
  };

  validateModifyStatus = () => {
    const { taskData, session } = this.props;

    if (taskData.hasGroup || taskData.hasRoute) return false;
    if (
      taskData.status === Status.CANCEL_BY_PARTNER ||
      taskData.status === Status.CANCEL ||
      taskData.status === Status.FINISH ||
      taskData.status === Status.REVIEW
    ) {
      return false;
    }
    if (RoleUtils.isUserClient(session.user)) return false;
    if (RoleUtils.isUserSuperAdministratorAndSuperAdminViewer(session.user)) return true;

    const prefs = session?.accountPreferences;
    if (
      (prefs?.allowAdminToModifyTasksStatus && RoleUtils.isUserAdministrator(session.user)) ||
      (prefs?.allowManagerToModifyTasksStatus && RoleUtils.isUserManager(session.user))
    ) {
      return true;
    }
    return false;
  };

  setStatusParent = (status) => {
    this.props.taskData.statusInfo = status;
  };

  setDefaultFalseEdit = () => {
    this.props.fielderModal.closeAllModals();
  };

  setDefaultFalseModalEdit = () => {
    this.props.fielderModal.closeAllModals();
  };

  editModal = () => {
    this.props.fielderModal.setContent(null);
    this.props.fielderModal.closeModal(POP_EDIT_BRANCH);
    const dynamicContent = (
      <DetailEditBranchOffice
        {...this.props}
        branchesToShow={{ id: this.props.taskData.branchId }}
        showModalDetailEditBranch
        idAccountBranch={this.props.taskData.idAccount}
        setDefaultFalseModal={this.setDefaultFalseEdit}
        setDefaultFalse={this.setDefaultFalseModalEdit}
        showLocationMessage
      />
    );
    this.props.fielderModal.setContent(POP_EDIT_BRANCH, dynamicContent);
    this.props.fielderModal.openModal(POP_EDIT_BRANCH);
  };

  renderModal = (showModal, titleKey, id, fullWidth = false) => {
    if (!showModal) return null;
    return (
      <Modal
        id={id}
        title={this.props.lan[titleKey]}
        icon={<img src={BranchIcon} alt={this.props.lan[titleKey]} />}
        fullWidth={fullWidth}
      />
    );
  };

  render() {
    const { lan, taskData, showIconModify, statusEditTask, canNotEdit, idTask } = this.props;
    const { edit, showModifyTaskStatus, taskTypes, isAllowedToEditTask } = this.state;

    return (
      <>
        {this.renderModal(true, 'editBranch', POP_EDIT_BRANCH, true)}
        {showModifyTaskStatus && (
          <ModifyTaskStatus
            handleCloseModifyStatus={this.closeModifyStatus}
            taskTypeId={taskData.taskTypeId}
            taskTypes={taskTypes}
            statusTask={taskData.status}
            idTask={idTask}
            {...this.props}
          />
        )}
        {edit ? (
          <Popup
            size="lg"
            closeButton
            onClose={() => this.setState({ edit: false })}
            title={lan.editTask}
            show
            width="lg"
            centerprop={false}
          >
            <EditorTask onCloseModal={this.props.onCloseModal} taskInfo={this.props.allData.taskInfo} {...this.props} />
          </Popup>
        ) : (
          <Grid container spacing={1.5}>
            {/* Left column */}
            <Grid size={{ xs:12, md:6 }}>
              {/* Header row: id, status, actions */}
              <Grid container direction="row" sx={{ justifyContent: "space-between", alignItems: "center", }} spacing={1}>
                <Grid size={{ xs:12, md:4 }}>
                  <LabelText label={lan.idCustom} text={taskData.number} />
                </Grid>
                <Grid size={{ xs:6, md:6 }} sx={{ pt: 1.5 }}>
                  <TaskStatus task={taskData} setStatusParent={this.setStatusParent} />
                </Grid>
                {showIconModify && this.validateModifyStatus() && isAllowedToEditTask && (
                  <Grid size={{ xs:6, md:1 }} sx={{ pt: 1.5 }}>
                    <Tooltip title={lan.modifyTaskStatus}>
                      <SmartIconButton id="modify-task-status-button" onClick={this.clickModifyStatus} size="large">
                        <TrendingUp fontSize="inherit" />
                      </SmartIconButton>
                    </Tooltip>
                  </Grid>
                )}
                {statusEditTask && !canNotEdit && isAllowedToEditTask && (
                  <Grid size={{ xs:6, md:1 }} sx={{ pt: 1.5 }}>
                    <Tooltip title={lan.editTask}>
                      <SmartIconButton
                        id="edit-task-button"
                        onClick={() => this.setState({ edit: true })}
                        size="large"
                      >
                        <EditNoteOutlined fontSize="inherit" />
                      </SmartIconButton>
                    </Tooltip>
                  </Grid>
                )}
              </Grid>

              {taskData.idParent > 0 && (
                <Box sx={{ mt: 1.5 }}>
                  <LabelText label={lan.idParentTask} text={taskData.idParent} />
                </Box>
              )}

              <Box sx={{ mt: 1.5 }}>
                <LabelText label={lan.folio} text={taskData.folio} />
              </Box>

              <Box sx={{ mt: 1.5 }}>
                <LabelText label={lan.caseNumber} text={taskData.caseNumber} />
              </Box>

              {taskData.showBranchFields && (
                <Box sx={{ mt: 1.5 }}>
                  <LabelText label={lan.idBranch} text={taskData.branchId} />
                </Box>
              )}

              {taskData.showBranchFields && (
                <Box sx={{ mt: 1.5 }}>
                  <LabelText label={lan.taskBranchIdCustom} text={taskData.branchIdCustom} />
                </Box>
              )}

              <Box sx={{ mt: 1.5 }}>
                <LabelText
                  label={taskData.showClientFields ? lan.nameOfClient : lan.nameOfBranch}
                  text={taskData.client?.name}
                  showMoreInfo
                  onMoreInfo={this.editModal}
                />
              </Box>

              {taskData.showClientFields && (
                <Box sx={{ mt: 1.5 }}>
                  <LabelText label={lan.lastNameClient} text={taskData.lastName} />
                </Box>
              )}

              {taskData.showClientFields && (
                <Box sx={{ mt: 1.5 }}>
                  <LabelText label={lan.userName} text={taskData.userName} />
                </Box>
              )}

              {!taskData.showClientFields && (
                <Box sx={{ mt: 1.5 }}>
                  <LabelText label={lan.company} text={taskData.company} />
                </Box>
              )}

              {taskData.showClientFields && (
                <Box sx={{ mt: 1.5 }}>
                  <LabelText label={lan.phoneNumberClient} text={taskData.client?.phone} />
                </Box>
              )}

              {taskData.showClientFields && (
                <Box sx={{ mt: 1.5 }}>
                  <LabelText label={lan.emailOfClient} text={taskData.client?.mail} />
                </Box>
              )}

              {taskData.userCreateTask && (
                <Box sx={{ mt: 1.5 }}>
                  <LabelText label={lan.createdTaskBy} text={taskData.userCreateTask} />
                </Box>
              )}
            </Grid>

            {/* Right column */}
            <Grid size={{ xs:12, sm:6 }}>
              <Box sx={{ mt: { xs: 0.5, md: 0 } }}>
                <LabelText label={lan.typeTask} text={taskData.taskType} />
              </Box>

              <Box sx={{ mt: 1.5 }}>
                <LabelText label={lan.serviceOrigin} text={taskData.serviceOrigin} />
              </Box>

              {taskData.showMyTaskPartner && (
                <Box sx={{ mt: 1.5 }}>
                  <LabelText label={lan.assignedPartner} text={taskData.taskPartner} />
                </Box>
              )}

              <Box sx={{ mt: 1.5 }}>
                <LabelText label={lan.priority} text={taskData.priority} />
              </Box>

              <Box sx={{ mt: 1.5 }}>
                <LabelArea label={lan.descriptionTask} text={taskData.description} />
              </Box>

              <Box sx={{ mt: 1.5 }}>
                <LabelArea label={lan.clientComment} text={taskData.rateComment} />
              </Box>

              <Grid container alignItems="center" sx={{ mt: 1 }}>
                <Grid size={{ xs:12, sm:3 }}>
                  <Typography sx={{ fontSize: 13, fontWeight: 600 }}>
                    {lan.rating}
                  </Typography>
                </Grid>
                <Grid size={{ xs:12, sm:9 }}>
                  <Rating
                    value={Number(taskData.rating) || 0}
                    precision={0.5}
                    readOnly
                    sx={{ verticalAlign: 'middle' }}
                  />
                </Grid>
              </Grid>

              <Box sx={{ mt: 1.5 }}>
                <Tags tags={taskData.tags} noTags={taskData.noTags} lan={lan} />
              </Box>
            </Grid>
          </Grid>
        )}
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  session: state.utils.session,
});
export default connect(mapStateToProps)(TaskInfo);
export function withSnackbar(Component) {
  return function WrappedComponent(props) {
    const fielderModal = useModal();
    return <Component {...props} fielderModal={fielderModal} />;
  };
}
//Original code:
/*import React, { Component } from 'react';
import Status from 'FielderUtils/status/taskStatus';
import RoleUtils from 'FielderUtils/roles/roleUtils';
import EditIcon from '@assets/icons/edit-icon.svg';
import ModifyTask from '@assets/icons/arrow-modify.svg';
import taskConst from 'FielderUtils/roleManagementConst/taskConst';
import Modal from '~/FielderElements/Modal';
import BranchIcon from '@assets/icons/branch-icon.svg';
import {
	listToTree,
	getAllTaskTypeList,
	getAllTaskTypeListPartner,
	hasTaskTypeDynamoTable,
	hasTaskTypeDynamoTablePartner,
} from 'FielderUtils/taskType/taskType';
import Grid from '@mui/material/Grid2';
import { connect } from 'react-redux';
import StarRatings from 'react-star-ratings';
import Tooltip from '@mui/material/Tooltip';
import ModifyTaskStatus from './ModifyTaskStatus';
import { isRoleValid } from '../../core/utils/roles/validateRoles';
import EditorTask from '../CreateTask/EditorTask';
import Popup from '../Popup';
import TaskStatus from '~/Status/TaskStatus';
import { FIELDER } from '@core/constants/base.constants';
import DetailEditBranchOffice from 'OldComponents/BranchOffices/DetailEditBranchOffice';
import { FielderHard } from '@core/theme/baseTheme';

const { pop: POP_ID } = FIELDER.idElement;
const POP_EDIT_BRANCH = POP_ID.formBranch.replace('{0}', 'branchModal5');
class TaskInfo extends Component {
	constructor(props) {
		super(props);
		this.state = {
			edit: false,
			statusTask: false,
			isAllowedToEditTask: false,
			showModifyTaskStatus: false,
			taskTypes: [],
			branchesToShow: {
				id: props.idBranch,
			},
		};
	}
	componentDidMount = () => {
		let state = this.state;
		state.isAllowedToEditTask = isRoleValid(taskConst.TASKS, taskConst.EDIT, this.props.session.roles);
		this.setState(state);
		let partnerTaskRelations = this.props.partnerTaskRelations;
		let idAccount = this.props.session.user.idAccount;
		let idUser = this.props.session.user.idUser;
		if (
			partnerTaskRelations !== undefined &&
			partnerTaskRelations != null &&
			partnerTaskRelations.accountOwner != null &&
			partnerTaskRelations.accountOwner.id !== idAccount &&
			partnerTaskRelations.accountOwner.idUserClient !== idUser &&
			partnerTaskRelations.partnerLevel === 1
		) {
			var idAccountPartner = partnerTaskRelations.accountOwner.id;
			var idUserPartner = partnerTaskRelations.accountOwner.idUserClient;
			this.executeGetAllTaskInfoPartner(idAccountPartner, idUserPartner);
		} else {
			this.executeGetAllTaskInfo();
		}
	};
	executeGetAllTaskInfo = () => {
		hasTaskTypeDynamoTable().then((taskTypeFunctionality) => {
			if (taskTypeFunctionality) {
				getAllTaskTypeList(
					(formatTypes, taskTypes) => {
						let types = listToTree(formatTypes);
						let state = this.state;
						state.taskTypes = types;
						state.taskTypeFunctionality = taskTypeFunctionality;
						this.setState(state);
					},
					this.props,
					true
				);
			}
		});
	};
	executeGetAllTaskInfoPartner = (idAccountPartner, idUserPartner) => {
		hasTaskTypeDynamoTablePartner(idAccountPartner, idUserPartner).then((taskTypeFunctionality) => {
			if (taskTypeFunctionality) {
				getAllTaskTypeListPartner(
					(formatTypes, taskTypes) => {
						let types = listToTree(formatTypes);
						let state = this.state;
						state.taskTypes = types;
						state.taskTypeFunctionality = taskTypeFunctionality;
						this.setState(state);
					},
					this.props,
					idAccountPartner,
					idUserPartner
				);
			}
		});
	};
	LabelText = (props) => {
    let text;
    if (Array.isArray(props.text))
      text = props.text.join(' > ');
    else text = props.text;
		return (
			<Grid size={12} className={props.className}>
				<Grid container className='my-2'>
					<Grid size={12} className={'td-label-input ' + props.labelClass}>{props.label}</Grid>
					{props.showMoreInfo && (
						<>
							<Grid size={12} className='d-flex justify-content-end'>
								<span
									onClick={this.editModal}
									style={{ textDecoration: 'underline', color: FielderHard, cursor: 'pointer' }}
								>
								{this.props.lan.moreInformation}
								</span>
							</Grid>
						</>
					)}
				</Grid>
				<Grid container>
					<Grid size={12} className={'td-default-text align-left ' + props.textClass}>
						<input type='text' className='task-details-input' defaultValue={text} disabled style={{ width: '100%' }} />
					</Grid>
				</Grid>
			</Grid>
		);
	};
	LabelArea = (props) => {
		return (
			<Grid size={12} className={props.className}>
				<Grid container className='my-2'>
					<Grid size={12} className={'td-label-input ' + props.labelClass}>{props.label}</Grid>
				</Grid>
				<Grid container>
					<Grid size={12} className={'td-default-text align-left ' + props.textClass}>
						<textarea
							rows='3'
							cols='20'
							className='taskinfo-scrollTextarea task-details-input'
							value={props.text}
							disabled
							style={{ width: '100%' }}
						/>
					</Grid>
				</Grid>
			</Grid>
		);
	};
  Tags = (props) => {
    return (
      <Grid container>
        <Grid size={12}>{props.lan.tags}</Grid>
        {props.tags.length > 0 ? (
          <div className='taskinfo-scrollTextarea'>
            <Grid size={12} container>
              {props.tags.map((type, i) => (
                <div className='mt-1'>
                  <div className='container'>
                    <span id={'TaskInfo-tag-' + i} className='mr-3'>
                      #{type}{' '}
                    </span>
                  </div>
                </div>
              ))}
            </Grid>
          </div>
        ) : (
          <Grid size={12}>
            <input
              type='text'
              className='task-details-input'
              defaultValue={props.noTags}
              disabled
              style={{ width: '100%' }}
            />
          </Grid>
        )}
      </Grid>
    );
  };
	clickModifyStatus = () => {
		this.setState({ showModifyTaskStatus: true });
		this.props.changeOpacity();
	};
	closeModifyStatus = (refresh) => {
		this.setState({ showModifyTaskStatus: false });
		this.props.changeOpacityReset();

		if (refresh) {
			this.props.executeRefresh();
		}
	};
	validateModifyStatus = () => {
		if (this.props.taskData.hasGroup || this.props.taskData.hasRoute) {
			return false;
		} else if (
			this.props.taskData.status === Status.CANCEL_BY_PARTNER ||
			this.props.taskData.status === Status.CANCEL ||
			this.props.taskData.status === Status.FINISH ||
			this.props.taskData.status === Status.REVIEW
		) {
			return false;
		} else if (RoleUtils.isUserClient(this.props.session.user)) {
			return false;
		} else if (RoleUtils.isUserSuperAdministratorAndSuperAdminViewer(this.props.session.user)) {
			return true;
		} else if (
			(this.props.session &&
				this.props.session.accountPreferences &&
				this.props.session.accountPreferences.allowAdminToModifyTasksStatus &&
				RoleUtils.isUserAdministrator(this.props.session.user)) ||
			(this.props.session &&
				this.props.session.accountPreferences &&
				this.props.session.accountPreferences.allowManagerToModifyTasksStatus &&
				RoleUtils.isUserManager(this.props.session.user))
		) {
			return true;
		} else {
			return false;
		}
	};
	setStatusParent = (status) => {
		this.props.taskData.statusInfo = status;
	};
	setDefaultFalseEdit = () => {
		this.props.fielderModal.closeAllModals();
	}
	setDefaultFalseModalEdit = () => {
		this.props.fielderModal.closeAllModals();
	}
	editModal = () => {
			this.props.fielderModal.setContent(null);
			this.props.fielderModal.closeModal(POP_EDIT_BRANCH);
			const dynamicContent = (
				<DetailEditBranchOffice
					{...this.props}
					branchesToShow={{id:this.props.taskData.branchId}}
					showModalDetailEditBranch={true}
					idAccountBranch={this.props.taskData.idAccount}
					setDefaultFalseModal={this.setDefaultFalseEdit}
					setDefaultFalse={this.setDefaultFalseModalEdit}
					showLocationMessage={true}
				/>
			);
			this.props.fielderModal.setContent(POP_EDIT_BRANCH, dynamicContent);
			this.props.fielderModal.openModal(POP_EDIT_BRANCH);
		};
  renderModal = (showModal, titleKey, id, fullWidth = false) => {
    if (!showModal) return null;
    return (
      <Modal
        id={id}
        title={this.props.lan[titleKey]}
        icon={<img src={BranchIcon} alt={this.props.lan[titleKey]} />}
        fullWidth={fullWidth}
      />
    );
  };
	render() {
		return (
			<>
				{this.renderModal(true, 'editBranch', POP_EDIT_BRANCH, true)}
					{this.state.showModifyTaskStatus && (
						<ModifyTaskStatus
							handleCloseModifyStatus={(refresh) => this.closeModifyStatus(refresh)}
							taskTypeId={this.props.taskData.taskTypeId}
							taskTypes={this.state.taskTypes}
							statusTask={this.props.taskData.status}
							idTask={this.props.idTask}
							{...this.props}
						/>
					)}
					{this.state.edit && (
						<Popup
							size='lg'
							closeButton
							onClose={() => this.setState({ edit: false })}
							title={this.props.lan.editTask}
							show
							width='lg'
							centerprop={false}
						>
							<EditorTask onCloseModal={this.props.onCloseModal} taskInfo={this.props.allData.taskInfo} {...this.props} />
						</Popup>
					)}
					{!this.state.edit && (
						<Grid container>
							<Grid size={6} sx={{ pr: 1 }}>
                <Grid size={12}>
                  <Grid container direction="row" sx={{ justifyContent: "center", alignItems: "center" }} spacing={1}>
                    <Grid size={4}>
                      <this.LabelText
                        label={this.props.lan.idCustom}
                        text={this.props.taskData.number}
                        className='mt-3'
                        textClass='td-task-number'
                      />
                    </Grid>
                    <Grid size={6} sx={{ pt: 4 }}>
                      <TaskStatus task={this.props.taskData} setStatusParent={this.setStatusParent}  />
                    </Grid>
                    {this.props.showIconModify && this.validateModifyStatus() && this.state.isAllowedToEditTask && (
                      <Grid size={1} sx={{ pt: 3 }}>
                        <Tooltip title={this.props.lan.modifyTaskStatus}>
                          <img
                            id='modify-task-status-button'
                            src={ModifyTask}
                            className='edit-cursor-pointer'
                            style={{ height: '25px', width: '22px' }}
                            alt=''
                            onClick={this.clickModifyStatus}
                          />
                        </Tooltip>
                      </Grid>
                    )}
                    {this.props.statusEditTask && !this.props.canNotEdit && this.state.isAllowedToEditTask && (
                      <Grid size={1} sx={{ pt: 3 }}>
                        <img
                          id='edit-task-button'
                          src={EditIcon}
                          className='icon edit-cursor-pointer'
                          onClick={() => this.setState({ edit: true })}
                        />
                      </Grid>
                    )}
                  </Grid>
                </Grid>
								{this.props.taskData.idParent > 0 && (
                  <this.LabelText label={this.props.lan.idParentTask} text={this.props.taskData.idParent} className='my-3' />
								)}
									<this.LabelText label={this.props.lan.folio} text={this.props.taskData.folio} className='my-3' />
									<this.LabelText label={this.props.lan.caseNumber} text={this.props.taskData.caseNumber} className='my-3' />
								{this.props.taskData.showBranchFields && (
                  <this.LabelText label={this.props.lan.idBranch} text={this.props.taskData.branchId} className='my-3' />
								)}
								{this.props.taskData.showBranchFields && (
                  <this.LabelText label={this.props.lan.taskBranchIdCustom} text={this.props.taskData.branchIdCustom} className='my-3' />
								)}
									<this.LabelText
                    label={this.props.taskData.showClientFields ?
                      this.props.lan.nameOfClient : this.props.lan.nameOfBranch}
                    showMoreInfo={true} text={this.props.taskData.client.name} className='my-3' />
								{this.props.taskData.showClientFields && (
                  <this.LabelText label={this.props.lan.lastNameClient} text={this.props.taskData.lastName} className='my-3' />
								)}
								{this.props.taskData.showClientFields && (
                  <this.LabelText label={this.props.lan.userName} text={this.props.taskData.userName} className='my-3' />
								)}
								{!this.props.taskData.showClientFields && (
                  <this.LabelText label={this.props.lan.company} text={this.props.taskData.company} className='my-3' />
								)}
								{this.props.taskData.showClientFields && (
                  <this.LabelText label={this.props.lan.phoneNumberClient} text={this.props.taskData.client.phone} className='my-3' />
								)}
								{this.props.taskData.showClientFields && (
                  <this.LabelText label={this.props.lan.emailOfClient} text={this.props.taskData.client.mail} className='my-3' />
								)}
								{this.props.taskData.userCreateTask !== undefined &&
									this.props.taskData.userCreateTask &&
									this.props.taskData.userCreateTask !== '' && (
                    <this.LabelText label={this.props.lan.createdTaskBy} text={this.props.taskData.userCreateTask} className='my-3' />
									)}
							</Grid>
							<Grid size={6} sx={{ pl: 1 }}>
                <this.LabelText label={this.props.lan.typeTask} text={this.props.taskData.taskType} className='my-3' />
                <this.LabelText label={this.props.lan.serviceOrigin} text={this.props.taskData.serviceOrigin} className='my-3' />
								{this.props.taskData.showMyTaskPartner && (
                  <this.LabelText label={this.props.lan.assignedPartner} text={this.props.taskData.taskPartner} className='my-3' />
								)}
									<this.LabelText label={this.props.lan.priority} text={this.props.taskData.priority} className='my-3' />
									<this.LabelArea label={this.props.lan.descriptionTask} text={this.props.taskData.description} className='my-3' />
									<this.LabelArea label={this.props.lan.clientComment} text={this.props.taskData.rateComment} className='my-3' />
                  <Grid size={12} container direction="row" sx={{ justifyContent: "center", alignItems: "center" }}>
                    <Grid size={3}>
                      {this.props.lan.rating}
                    </Grid>
                    <Grid size={9}>
                      <StarRatings
                        rating={this.props.taskData.rating}
                        starSpacing='5px'
                        starDimension='30px'
                        numberOfStars={5}
                        starRatedColor='yellow'
                        starHoverColor='yellow'
                      />
                    </Grid>
                  </Grid>
                  <Grid size={12} sx={{ pt: 1 }}>
                    <this.Tags tags={this.props.taskData.tags} noTags={this.props.taskData.noTags} lan={this.props.lan} />
                  </Grid>
							</Grid>
						</Grid>
					)}
			</>
		);
	}
}
const mapStateToProps = (state) => ({
	session: state.utils.session,
});
export default connect(mapStateToProps)(TaskInfo);
export function withSnackbar(Component) {
	return function WrappedComponent(props) {
		const fielderModal = useModal();
		return <Component {...props} fielderModal={fielderModal} />;
	}
}
*/
